module.exports = __webpack_public_path__ + "img/7.0ce5e23b.png";